import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { COMMENT_TYPES } from './types';

export interface ICreateCommentRequest {
  contactId: string;
  text: string;
  commentType: COMMENT_TYPES;
}

export interface ICreateDealCommentRequest {
  comment: string;
  commentActionType: COMMENT_TYPES;
}

const contactPath = '/contact-service/contact-comments';

export const requestCreateContactComment = async(comment: ICreateCommentRequest) => {
  try {
    await axios.post(contactPath, comment);
    Notistack.successMessage('Comment - Added Successfully');
  } catch (err) {
    const error = err as { response: { data: { message: string } } };
    Notistack.generalError(error?.response?.data?.message);
  }
};
export const requestCreateDealComment = async(dealId: string, comment: ICreateDealCommentRequest) => {
  try {
    await axios.post(`/deal-service/deals/${dealId}/comments`, comment);
    Notistack.successMessage('Comment - Added Successfully');
  } catch (err) {
    const error = err as { response: { data: { message: string } } };
    Notistack.generalError(error?.response?.data?.message);
  }
};
